(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hs-email-signup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hs-email-signup-v15')) {
    class HSEmailSignup extends HTMLElement {
      connectedCallback() {
        this.formId = (this.dataset.formId || '').trim();
        this.publicKey = (this.dataset.publicKey || '').trim();
        this.syncPopupSignups = this.dataset.syncPopupSignups !== 'false';
        this.popupFormIds = (this.dataset.popupFormIds || '')
          .split(/[\s,;]+/)
          .map((id) => id.replace(/^klaviyo-form-/, '').trim())
          .filter(Boolean);
        this.formRoot = this.querySelector('.hs-email-signup__klaviyo');
        this.statusRoot = this.querySelector('[data-hs-status]');
        this.statusTitle = this.querySelector('[data-hs-status-title]');
        this.statusText = this.querySelector('[data-hs-status-text]');
        this.copyHeading = this.querySelector('[data-hs-copy-heading]');
        this.copyText = this.querySelector('[data-hs-copy-text]');
        this.formWrap = this.querySelector('.hs-email-signup__form-wrap');

        this.defaultHeading = this.copyHeading?.textContent?.trim() || 'JOIN THE LIST';
        this.defaultTextHTML = this.copyText?.innerHTML || '';
        this.storageKey = this.formId ? `hs-email-signup:${this.formId}:subscribed` : '';
        // A shared, origin-local flag lets popup and embedded email signups use
        // the same copy. Keep the original key for existing embedded signups.
        this.sharedStorageKey = `hs-email-signup:${this.publicKey || window.location.host}:email-subscribed`;
        this.state = 'loading';
        this.dataset.state = 'loading';
        this.formCheckRaf = 0;

        // Never hide the section while Klaviyo initializes.
        this.setAttribute('data-hs-signup-ready', '');

        if (!this.formId) return;

        this.onFormEvent = this.handleFormEvent.bind(this);
        this.onFormClick = this.handleFormClick.bind(this);
        this.onStorage = this.handleStorageEvent.bind(this);
        window.addEventListener('klaviyoForms', this.onFormEvent);
        window.addEventListener('hs-email-signup:submit', this.onFormEvent);
        window.addEventListener('storage', this.onStorage);
        this.addEventListener('click', this.onFormClick, true);

        if (this.wasSubscribed()) {
          this.showSubscribedState();
          return;
        }

        // Klaviyo builds the embed in several DOM passes. Observe only inserted/
        // removed nodes. Watching attributes here caused our own styling classes
        // to trigger the observer again and could create a heavy render loop.
        if (this.formRoot) {
          this.formObserver = new MutationObserver(() => this.scheduleFormCheck());
          this.formObserver.observe(this.formRoot, { childList: true, subtree: true });
        }

        this.ensureKlaviyoScript();
        this.scheduleFormCheck();
        this.formCheckTimer = window.setTimeout(() => this.checkFormState(true), 5000);
      }

      disconnectedCallback() {
        window.removeEventListener('klaviyoForms', this.onFormEvent);
        window.removeEventListener('hs-email-signup:submit', this.onFormEvent);
        window.removeEventListener('storage', this.onStorage);
        this.removeEventListener('click', this.onFormClick, true);
        this.formObserver?.disconnect();
        window.clearTimeout(this.formCheckTimer);
        if (this.formCheckRaf) window.cancelAnimationFrame(this.formCheckRaf);
      }

      scheduleFormCheck() {
        if (this.formCheckRaf || this.state === 'subscribed' || this.state === 'declined') return;
        this.formCheckRaf = window.requestAnimationFrame(() => {
          this.formCheckRaf = 0;
          this.checkFormState();
        });
      }

      ensureKlaviyoScript() {
        this.ensureKlaviyoPreconnect();

        if (window.klaviyo || window._klOnsite) {
          this.scheduleFormCheck();
          return;
        }

        const existing = document.querySelector('script[src*="static.klaviyo.com/onsite/js/"]');
        if (existing) {
          // If Shopify/Klaviyo is already loading the onsite script, never add a
          // second copy. Just react when that existing request finishes.
          existing.addEventListener('load', () => this.scheduleFormCheck(), { once: true });
          return;
        }

        if (!this.publicKey) return;

        // A single shared loader prevents theme-editor section reloads from
        // requesting klaviyo.js more than once.
        if (!window.__hsKlaviyoLoaderPromise) {
          window.__hsKlaviyoLoaderPromise = new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.async = true;
            script.src = `https://static.klaviyo.com/onsite/js/${encodeURIComponent(this.publicKey)}/klaviyo.js`;
            script.dataset.hsKlaviyoLoader = 'true';
            script.addEventListener('load', resolve, { once: true });
            script.addEventListener('error', reject, { once: true });
            document.head.appendChild(script);
          });
        }

        window.__hsKlaviyoLoaderPromise
          .then(() => this.scheduleFormCheck())
          .catch(() => this.showEditorDiagnostic('Klaviyo.js could not load. Check the Public API Key / Site ID.'));
      }

      ensureKlaviyoPreconnect() {
        if (document.querySelector('link[data-hs-klaviyo-preconnect]')) return;
        const link = document.createElement('link');
        link.rel = 'preconnect';
        link.href = 'https://static.klaviyo.com';
        link.crossOrigin = 'anonymous';
        link.dataset.hsKlaviyoPreconnect = 'true';
        document.head.appendChild(link);
      }

      wasSubscribed() {
        if (this.hasCapturedSignup()) return true;
        try {
          return (this.storageKey && window.localStorage.getItem(this.storageKey) === '1') ||
            (this.syncPopupSignups && window.localStorage.getItem(this.sharedStorageKey) === '1') ||
            this.hasCapturedSignup();
        } catch (error) {
          return false;
        }
      }

      hasCapturedSignup() {
        return (window.__hsEmailSignupBridgeV1?.records() || []).some((detail) =>
          detail.formId === this.formId || this.isPopupEmailSignup(detail, detail.formId)
        );
      }

      rememberSubscribed() {
        // Store only a state flag, never the email address or submitted fields.
        for (const key of [this.storageKey, this.syncPopupSignups ? this.sharedStorageKey : '']) {
          if (!key) continue;
          try {
            window.localStorage.setItem(key, '1');
          } catch (error) {}
        }
      }

      handleStorageEvent(event) {
        if (event.key !== this.storageKey &&
            (!this.syncPopupSignups || event.key !== this.sharedStorageKey)) return;
        if (event.newValue === '1') this.showSubscribedState();
      }

      isPopupEmailSignup(detail, eventFormId) {
        if (!this.syncPopupSignups || !eventFormId) return false;
        if (this.publicKey && detail.companyId && String(detail.companyId) !== this.publicKey) return false;

        // Explicit IDs restrict syncing to the selected newsletter popup(s).
        if (this.popupFormIds.length) return this.popupFormIds.includes(eventFormId);
        const metadata = detail.metaData || detail.metadata || {};
        const hasEmail = detail.hsEmailCaptured ||
          (typeof metadata.email === 'string' && Boolean(metadata.email.trim()));
        const hasPhone = detail.hsPhoneCaptured || Boolean(metadata.phone_number || metadata.phone);
        // Some onsite versions omit contact metadata. The main submit event is
        // still a confirmed form conversion; do not require the email payload.
        // A known phone-only conversion remains excluded.
        return Boolean(hasEmail || !hasPhone);
      }

      checkFormState(finalCheck = false) {
        if (!this.formRoot || this.state === 'subscribed' || this.state === 'declined') return;

        const interactive = this.formRoot.querySelector(
          'form, input, select, textarea, button, [role="button"]'
        );
        const hasContent = this.formRoot.textContent.trim().length > 0;

        if (interactive || hasContent) {
          this.removeEditorDiagnostic();
          if (this.state !== 'signup') this.showSignupState();
          this.decorateControls();
          return;
        }

        if (finalCheck && this.dataset.designMode === 'true') {
          const hasKlaviyo = Boolean(
            window.klaviyo ||
            window._klOnsite ||
            document.querySelector('script[src*="static.klaviyo.com/onsite/js/"]')
          );

          if (!hasKlaviyo && !this.publicKey) {
            this.showEditorDiagnostic('Klaviyo onsite tracking is not loading. Enable the Klaviyo app embed, or enter the Klaviyo Public API Key / Site ID in this section.');
          } else {
            this.showEditorDiagnostic('Klaviyo loaded, but this embed did not render. Confirm the form is Published and its targeting allows this page/device.');
          }
        }
      }

      showEditorDiagnostic(message) {
        if (this.dataset.designMode !== 'true' || !this.formWrap) return;
        let diagnostic = this.formWrap.querySelector('[data-hs-klaviyo-diagnostic]');
        if (!diagnostic) {
          diagnostic = document.createElement('div');
          diagnostic.className = 'hs-email-signup__placeholder';
          diagnostic.setAttribute('data-hs-klaviyo-diagnostic', '');
          diagnostic.innerHTML = '<span class="hs-email-signup__placeholder-label">KLAVIYO NOT RENDERING</span><p></p>';
          this.formWrap.appendChild(diagnostic);
        }
        const text = diagnostic.querySelector('p');
        if (text) text.textContent = message;
      }

      removeEditorDiagnostic() {
        this.formWrap?.querySelector('[data-hs-klaviyo-diagnostic]')?.remove();
      }

      normalizeLabel(value) {
        return String(value || '')
          .toLowerCase()
          .replace(/[.,!]/g, '')
          .replace(/\s+/g, ' ')
          .trim();
      }

      decorateControls() {
        if (!this.formRoot) return;
        const expected = this.normalizeLabel(this.dataset.dismissLabel || 'No, thanks');
        const rows = this.formRoot.querySelectorAll('[data-testid="form-row"]');
        const controls = this.formRoot.querySelectorAll('button, [role="button"], input[type="button"], input[type="submit"]');

        // Compute row roles without clearing and rebuilding classes on every DOM
        // mutation. This keeps styling idempotent and avoids unnecessary layout.
        rows.forEach((row) => {
          const hasField = Boolean(row.querySelector('input:not([type]), input[type="email"], input[type="text"], input[type="tel"], select, textarea'));
          const rowControl = row.querySelector('button, [role="button"], input[type="button"], input[type="submit"]');
          let isDeclineRow = false;
          let isPrimaryRow = false;

          if (rowControl) {
            const labels = [rowControl.textContent, rowControl.getAttribute('aria-label'), rowControl.value];
            isDeclineRow = expected && labels.some((label) => this.normalizeLabel(label) === expected);
            isPrimaryRow = !isDeclineRow;
          }

          row.classList.toggle('hs-email-signup__field-row', hasField);
          row.classList.toggle('hs-email-signup__decline-row', Boolean(isDeclineRow));
          row.classList.toggle('hs-email-signup__primary-row', Boolean(isPrimaryRow));
        });

        controls.forEach((control) => {
          const labels = [control.textContent, control.getAttribute('aria-label'), control.value];
          const isDecline = expected && labels.some((label) => this.normalizeLabel(label) === expected);
          control.classList.toggle('hs-email-signup__decline-action', Boolean(isDecline));
          control.classList.toggle('hs-email-signup__primary-action', !isDecline);
        });
      }

      handleFormEvent(event) {
        const detail = event.detail || {};
        const eventFormId = String(detail.formId || detail.formID || '');
        const isEmbed = eventFormId === this.formId;

        // Klaviyo's submit event is its main conversion action. A popup close,
        // open, or stepSubmit must never be mistaken for a completed signup.
        if (detail.type === 'submit' && (isEmbed || this.isPopupEmailSignup(detail, eventFormId))) {
          this.rememberSubscribed();
          this.showSubscribedState();
          return;
        }

        // Closing another form must not change this section's decline state.
        if (!isEmbed) return;

        if (detail.type === 'close' && this.state !== 'subscribed') {
          this.showDeclinedState();
          return;
        }

        this.scheduleFormCheck();
      }

      handleFormClick(event) {
        const target = event.target instanceof Element ? event.target : null;
        const control = target?.closest('button, a, [role="button"], input[type="button"], input[type="submit"]');
        const formWrap = control?.closest('.hs-email-signup__klaviyo');
        if (!formWrap || !this.contains(formWrap)) return;

        const expected = this.normalizeLabel(this.dataset.dismissLabel || 'No, thanks');
        const labels = [control.textContent, control.getAttribute('aria-label'), control.value];
        const isDecline = expected && labels.some((label) => this.normalizeLabel(label) === expected);
        if (!isDecline) return;

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        this.showDeclinedState();
      }

      showSignupState() {
        this.state = 'signup';
        this.dataset.state = 'signup';
        this.setAttribute('data-hs-signup-ready', '');
        if (this.formRoot) this.formRoot.hidden = false;
        this.removeEditorDiagnostic();
        if (this.statusRoot) this.statusRoot.hidden = true;
        if (this.copyHeading) this.copyHeading.textContent = this.defaultHeading;
        if (this.copyText) this.copyText.innerHTML = this.defaultTextHTML;
      }

      showSubscribedState() {
        this.state = 'subscribed';
        this.dataset.state = 'subscribed';
        this.setAttribute('data-hs-signup-ready', '');
        if (this.formRoot) this.formRoot.hidden = true;
        this.removeEditorDiagnostic();
        if (this.statusRoot) this.statusRoot.hidden = false;
        if (this.copyHeading) this.copyHeading.textContent = this.dataset.subscribedMainHeading || 'THANKS FOR JOINING';
        if (this.copyText) this.copyText.textContent = this.dataset.subscribedMainText || 'You’re officially on the list.';
        if (this.statusTitle) this.statusTitle.textContent = this.dataset.subscribedHeading || 'YOU’RE ON THE LIST';
        if (this.statusText) this.statusText.textContent = this.dataset.subscribedText || 'You’re on the list for new merch, music, tour drops, and updates.';
      }

      showDeclinedState() {
        this.state = 'declined';
        this.dataset.state = 'declined';
        this.setAttribute('data-hs-signup-ready', '');
        if (this.formRoot) this.formRoot.hidden = true;
        this.removeEditorDiagnostic();
        if (this.statusRoot) this.statusRoot.hidden = false;
        if (this.copyHeading) this.copyHeading.textContent = this.dataset.declinedMainHeading || 'NO WORRIES';
        if (this.copyText) this.copyText.textContent = this.dataset.declinedMainText || 'You can join the list anytime.';
        if (this.statusTitle) this.statusTitle.textContent = this.dataset.declinedHeading || 'ALL GOOD';
        if (this.statusText) this.statusText.textContent = this.dataset.declinedText || 'The signup will be here if you change your mind.';
      }
    }

    customElements.define('hs-email-signup-v15', HSEmailSignup);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
